// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/Icon/Color.story.tsx with go/sail-next-tailor-docs-publisher 

import React from 'react';
import { Icon, css } from '@sail/ui';
import { cancelCircle } from '@sail/icons/react/Icon';
export const Color = () => <Icon icon={cancelCircle} uses={[css({
  fill: 'critical'
})]} />;